import React from 'react';
import { Trans } from '@lingui/react/macro';
import { Card } from '@ygtechnologies/rubus-ui';

import { BuyerCurrencyDisplay } from '@/buyer/components/BuyerCurrencyDisplay';
import { useOptionConfigurator } from '@/components/OptionConfigurator/OptionConfiguratorContext';

import theme from './ShowroomTotalCard.module.scss';

/**
 * Running cost overview for the showroom. Sits at the top of the filter sidebar and shows the
 * grand total of the current (trial) selection across all deadlines. `allDeadlinesConfiguratorData`
 * is the full, unfiltered data the showroom loads (deadlineId = null), so `grandPrice` already
 * sums every deadline.
 */
export const ShowroomTotalCard: React.FC = () => {
    const { allDeadlinesConfiguratorData } = useOptionConfigurator();
    const total = allDeadlinesConfiguratorData?.grandPrice ?? 0;

    return (
        <Card className={theme.card}>
            <span className={theme.label}>
                <Trans>Your selection</Trans>
            </span>
            <span className={theme.value}>
                <BuyerCurrencyDisplay value={total} />
            </span>
        </Card>
    );
};
